import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { TicketDetailsFragment } from '@api/fragments'
import { ITicketDetails } from '@api/types'

interface Payload {
  data: {
    ticket: ITicketDetails
  }
}

export default function details(id: string): Promise<ITicketDetails> {
  const variables = { id }

  return client.gql.query({ query, variables }).then(({ data: { ticket } }: Payload) => ticket)
}

const query = gql`
  query Ticket($id: ID!) {
    ticket: node(id: $id) {
      ...TicketDetailsFragment
    }
  }
  ${TicketDetailsFragment}
`
